import { Box, Text } from '@mantine/core';
import type { IModem } from '../../../../../../shared/types/modem';
import { InfoField } from '../../../../../ui/infoField/InfoField';
import { handleChangeLocaleTime } from '../../../../../../shared/utils/time';
import { renderActivateStatus } from '../../common/utils/format';

export default function ActivationInfo(props: { data: IModem }) {
  const { data } = props;

  const renderContractPeriod = (period: number) => {
    switch (period) {
      case 0:
        return '약정 없음';
      case 24:
        return '2년 약정';
      case 36:
        return '3년 약정';
      default:
        return '';
    }
  };
  return (
    <div>
      <Text fw={600} mb="xs">
        개통 상태
      </Text>
      <Box
        style={{
          borderTop: '1px solid var(--mantine-color-gray-3)',
          borderLeft: '1px solid var(--mantine-color-gray-3)',
          display: 'grid',
          gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
        }}
      >
        <InfoField label="개통 진행 상태">{renderActivateStatus(data.activateStatus)}</InfoField>
        <InfoField label="약정 여부">{renderContractPeriod(data.contractPeriod)}</InfoField>
        <InfoField label="개통일">{handleChangeLocaleTime(data.activateStartDt)}</InfoField>
        <InfoField label="개통 해지일">{handleChangeLocaleTime(data.activateEndDt)}</InfoField>
      </Box>
    </div>
  );
}
